module.exports = __webpack_public_path__ + "static/media/faster-refunds.cdf698c6.svg";